import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import {
  listContracts,
  statusCandidate,
  headerColumns1,
  ICandidat,
} from './../../../../core/models/candidat';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  EmptyCV,
  emptyFileTest,
  noCvSelected,
  noTestFileSelected,
  obligationSelect,
  serverError,
} from './../../../../core/models/messages';
import * as JSZip from 'jszip';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { Country, ICountry, State } from 'country-state-city';
import { SortDataService } from './../../../../core/services/sortdata';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { translations } from '../../../../core/models/call-offer';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { CompanyService } from '@core/services/company/company.service';
import { SubscriptionService } from '@core/services/subscription.service';
import { ExportService } from '@shared/services/export.service';
import { PageEvent } from '@angular/material/paginator';
declare var bootstrap: any;

@Component({
  selector: 'app-list-candidats',
  templateUrl: './list-candidats.component.html',
  styleUrls: ['./list-candidats.component.css'],
})
export class ListCandidatsComponent  implements OnInit {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  freeSearch: boolean = false;
  isFormSubmitted: boolean = false;
  isFreeSearchFromSubmitted: boolean = false;
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  title = 'Liste candidats ';
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
    { id: 2, name: 'Autres type de contrat' },
  ];

  contratRequest = listContracts;

  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  isCollapsed = true;
  ischecked = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  stateList: any = [];

  seeMore: boolean = false;
  isLoadSpinner: boolean = true;
  loadSpinner: boolean = false;
  pagination: boolean = false;
  startSearching: boolean = false;

  currentPage: number = 0;
  dataHeader: any = [];
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  currentSortDirection: number = 2;
  listcandidats: any;
  listNames: string[] = [];
  sortAttr = '';
  statut = statusCandidate;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  headerChecked: boolean = false;
  selectedCandidats: any = [];
  idsUsers: any[] = [];
  search: boolean = false;
  mobilities: any[] = [];
  countries: any[] = [];
  maxDate: Date = new Date();

  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  skillsList: { name_FR: string }[] = [];

  currentSortColumn: string = 'name'; // Initial column to sort by

  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns1;
  selectedCandidates: any = [];
  fromSelection: boolean = false;
  // Ajouter cette variable dans votre composant
  downloadCounter: number = 0;
  typeintervenant: any;

  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private candidatservice: EsnCandidatService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private sortDataService: SortDataService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private companyService: CompanyService,
    private subscriptionService: SubscriptionService,
    private exportService: ExportService,

  ) { }
  ngOnInit() {
    this.getListElementHeader();
    this.getListcandidat();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.getListSkills();

    registerLocaleData(localeFr);
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });
    this.maxDate = new Date();

    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }

  openInNewTab(url: string) {
    window.open(url, '_blank');
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  /* get indexes for pagination */
  getItems(event?: any) {
      if (
          (event && event.startIndex != this.startIndex) ||
          this.endIndex != event.endIndex ||
          this.pageSize != event.pageSize ||
          this.currentPage != event.currentPage
      ) {
          this.startIndex = event.startIndex;
          this.endIndex = event.endIndex;
          this.pageSize = event.pageSize;
          this.currentPage = event.currentPage;

        if (this.isFormSubmitted) {
            this.searchCandidat(this.currentPage);
        } else if(this.isFreeSearchFromSubmitted){
            this.freeSearchCandidat(this.currentPage);
        }else {
            this.getListcandidat();
        }
      }
  }

  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
    // Si aucun formulaire n'est actif, activer le formulaire cliqué
    if (this.activeForm === null) {
      this.activeForm = form;

      // Désactiver le formulaire non actif
      if (form === 'freeSearch') {
        this.freeSearchForm.enable(); // Activer le formulaire libre
        // this.searchForm.disable(); // Désactiver le formulaire guidé
      } else if (form === 'guidedSearch') {
        this.searchForm.enable(); // Activer le formulaire guidé
        // this.freeSearchForm.disable(); // Désactiver le formulaire libre
      }
    }
  }

  updateCandidats() {
    let count = 0;
    this.headerChecked = false;
    this.listcandidats.forEach((candidate: any) => {
      // Check if the candidate's ID exists in selectedCandidats
      const isSelected = this.selectedCandidats.some((selected: any) => selected.uuid === candidate.uuid);
      // Update the `checked` property based on the existence in selectedCandidats
      if (isSelected) {
        candidate.checked = true;
        candidate.headerChecked = true;
        count++;

      }
    });
    if (this.selectedCandidats.length === this.pageSize && count == 5) {
      this.headerChecked = true;
    }
  }

  getListElementHeader() {
    if (!this.typeintervenant) {
      this.candidatservice
        .getHeaderElements(10)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            //@TEMPORARY: temporary hide column 'Client Final'
            this.dataHeader = res.data?.filter((item: { name: string; }) => item.name !== "Client Final");;

            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });

          },
          error: () => { },
        });
    } else {
      this.candidatservice
        .listPageActorIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => { },
        });
    }
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.candidatservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => { },
          error: () => { },
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.candidatservice
        .changeSubPageStateIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => { },
          error: () => { },
        });
    }
  }

  rowClick(candidat: ICandidat, index: number) {
    this.listcandidats[index].checked = !this.listcandidats[index].checked;
    if (this.listcandidats[index].checked) {
      this.selectedCandidats.push(candidat);
    } else {
      const selectedIndex = this.selectedCandidats.findIndex(
        (item: any) => item === this.listcandidats[index]
      );
      if (selectedIndex !== -1) {
        this.selectedCandidats.splice(selectedIndex, 1);
      }
    }
  }

  getListcandidat() {
      this.spinner.show();
              const params = {
                per_page: this.pageSize,
                page: this.currentPage}
      this.candidatservice.getListcandidat(params).subscribe({
          next: (response) => {
              this.spinner.hide();
              if (response.data?.data?.length) {
                  this.listcandidats = response.data?.data;
                  this.totalItems = response.data.total;
                  this.updateCandidats();
              }
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }

  downloadFiles(type: string, fileName?: any, typeFile?: string) {

      if (type == 'single' && fileName) {
        if (fileName.cv || fileName.file_test) {
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${fileName.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${fileName?.file_test}`;
          this.showGlobalSpinner();
          this.candidatservice.downloadFile(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], { type: 'application/octet-stream' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${fileName.first_name}_${fileName.last_name}_CV.${fileName!.cv.split('.').pop()}`
                : `${fileName.first_name}_${fileName.last_name}_Réponses_Test_QCM_WEGESTU.pdf`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);

              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (!typeFile) {
          let allCvNull = true;

          // Vérifie chaque candidat pour voir s'il a un CV valide
          for (let i = 0; i < this.selectedCandidats.length; i++) {
            const candidat = this.selectedCandidats[i];
            if (candidat.cv && candidat.cv !== 'null') {
              allCvNull = false; // S'il y a un CV valide, marquez allCvNull comme false et sortez de la boucle
              break;
            }
          }
          if (allCvNull) {
            this.toastrService.info(noCvSelected);
          } else {
            this.downloadPdfFiles(typeFile);
          }
        } else {
          let datafileTest = this.selectedCandidats.map((el: any) => {
            return !el.file_test;
          });
          if (!datafileTest.includes(false)) this.toastrService.info(noTestFileSelected);
          else if (
            this.selectedCandidats.length == 1 &&
            !this.selectedCandidats[0].file_test
          )
            this.toastrService.info(emptyFileTest);
          else this.downloadPdfFiles(typeFile);
        }
      } else {
        this.toastrService.info(obligationSelect);
      }
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {

          return {
            url: `${this.url}/ResponseCandidate/GetFile/${el?.file_test}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test
          };
        }
      }
    );
    // this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.first_name}_${pdfUrl.last_name
                }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.first_name}_${pdfUrl.last_name
                }_Réponses_Test_QCM_WEGESTU.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          () => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip');
          this.selectedCandidats = [];
          this.headerChecked = false;
          this.searchCandidat();
        } else {
          saveAs(content, 'Réponse_qcm.zip');
          this.selectedCandidats = [];
          this.headerChecked = false;
          this.searchCandidat();
        }
      });
    });
    this.selectedCandidats.map((el: ICandidat) => {
      el.checked = false;
    });
    this.headerChecked = false;
    this.selectedCandidats = [];
  }
  exportCvWegest(data: any) {
    this.spinner.show()
    let exportSuccess = false;
    this.candidatservice.exportCvWegestCandidatList(data.uuid).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, 'CvWegest.pdf');
        exportSuccess = true;
        if (exportSuccess) {
          this.toastrService.success('Fichier exporté avec succès');
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastrService.error(serverError);
      },
    });
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }

  exportCandidats(file?: File) {
    if (this.selectedCandidats.length > 0) {
      for (const iterator of this.selectedCandidats) {
        this.idsUsers.push(iterator.uuid);
      }
      let data ={ 'ids' : this.idsUsers};
      this.candidatservice.exportCandidat(file, data).subscribe({
        next: (res: ArrayBuffer) => {
          this.spinner.hide();
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, 'RH_Profils.xlsx');
          this.toastrService.success('Fichier exporté avec succès');
          this.headerChecked = false;
          this.idsUsers = [];
          window.location.reload();
          this.searchCandidat();
        },
        error: (err) => {
          this.spinner.hide();
          this.idsUsers = []
          if (err.error instanceof ArrayBuffer) {
            // Convert ArrayBuffer to string
            const decoder = new TextDecoder('utf-8');
            const errorText = decoder.decode(err.error);

            try {
              const errorJson = JSON.parse(errorText);
              if (errorJson.message) {
                this.toastrService.error(errorJson.message);
              } else {
                this.toastrService.error('An unexpected error occurred.');
              }
            } catch (parseError) {
              this.toastrService.error('An error occurred while processing the error message.');
            }
          } else {
            this.toastrService.error('An unexpected error occurred.');
          }
        },
      });
    } else {
      this.spinner.hide();
      this.toastrService.info('Veuillez sélectionner au moins un candidat.');
    }
  }

  downloadreponse(candidat: any) {
    // if(!this.selectedCandidate.cv) {this.toastr.info(EmptyCV)}
    // else{
    this.spinner.show();
    const fileUrl = `${this.url}/User/file/gallery_cvs/${candidat.file_test}`;
    this.candidatservice.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `${candidat.first_name}_${candidat.last_name
        }_CV.${candidat.cv.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
    // }
  }

  changeSelectCandidats(event: any, type: string, candidat?: ICandidat) {
    if (type === 'allCandidats') {
      this.fromSelection = event.target.checked ? true : false;
      this.headerChecked = event.target.checked;

      // Bascule la sélection/désélection de toutes les lignes
      this.listcandidats.forEach((candidat: ICandidat) => {
        candidat.checked = this.headerChecked;

        // Mettre à jour la liste des candidats sélectionnés
        if (this.headerChecked) {
          if (
            !this.selectedCandidats.some(
              (el: ICandidat) => el.uuid === candidat.uuid
            )
          ) {
            this.selectedCandidats.push({ ...candidat, checked: true });
          }
        }
        else {
          this.selectedCandidats = this.selectedCandidats.filter(
            (el: ICandidat) => el.uuid !== candidat.uuid
          );
        }
        if (this.headerChecked === false) {
          this.listcandidats.forEach((candidate: any) => {

            candidate.checked = false;

          });
        }
      });
    }
    else {
      if (candidat) {
        if (event.target.checked) {
          // Check if all individual checkboxes are checked
          this.headerChecked = this.listcandidats.every((c: any) => c.checked);

          // Vérifier si le candidat n'est pas déjà présent dans le tableau
          if (
            !this.selectedCandidats.some(
              (el: ICandidat) => el.uuid === candidat.uuid
            )
          ) {
            this.selectedCandidats.push({ ...candidat, checked: true });
            candidat.checked = true;
          }
        } else {
          // Filtrer les candidats qui ne correspondent pas à l'ID du candidat actuel
          this.selectedCandidats = this.selectedCandidats.filter(
            (el: ICandidat) => el.uuid !== candidat.uuid
          );
          candidat.checked = false;

          // Uncheck the header checkbox
          this.headerChecked = false;
        }
      }
      else {
        // Si le type n'est pas 'allCandidats' et aucun candidat n'est spécifié, cela signifie que
        // l'action provient du bouton "Décocher tout"
        this.listcandidats.forEach((el: ICandidat) => {
          el.checked = false;
        });

        // Mettre à jour le tableau des candidats sélectionnés
        this.selectedCandidats = [];

        // Mettre à jour la propriété headerChecked
        this.headerChecked = false;
      }

      const nombreCoches = this.selectedCandidats.filter(
        (el: ICandidat) => el.checked
      ).length;

      if (nombreCoches > 3) {
        this.ischecked = false;
      } else {
        this.ischecked = true;
      }
      this.updateCandidats()
    }
  }
  navigateToCompareCandidats() {
    const nombreCoches = this.selectedCandidats.filter(
      (el: ICandidat) => el.checked
    ).length;
    if (nombreCoches > 3) {
      this.ischecked = false;
      this.toastrService.error(
        'Impossible de sélectionner plus de 3 candidats'
      );
    } else {
      const selectedIds = this.selectedCandidats.map(
        (candidat: any) => candidat.uuid
      );
      const url = [
        '/candidats/compare-candidats',
        { candidatsIds: selectedIds },
      ];
      // Opening link in a new tab
      window.open(this.router.createUrlTree(url).toString(), '_self');
      this.selectedCandidats = [];
      this.ischecked = true;
    }
  }

  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        // this.toastrService.error(serverError)
      },
    });
  }

  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  alreadyConverted = false;
  convertKToNumber(value: any): number {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
      // Si la valeur se termine par 'k'
      const numericValue = parseFloat(value.slice(0, -1));
      if (!isNaN(numericValue)) {
        // Convertir en multipliant par 1000
        this.alreadyConverted = true; // Marquer comme déjà convertie
        return numericValue * 1000;
      }
    } else if (!isNaN(value)) {
      // Si la valeur est déjà un nombre
      if (!this.alreadyConverted) {
        this.alreadyConverted = true; // Marquer comme déjà convertie
        return parseFloat(value) * 1000;
      } else {
        return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
      }
    }

    // Si aucune condition n'est remplie, retourner une valeur par défaut
    return 0; // Ou une autre valeur par défaut appropriée
  }

  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_user: ['', data?.ID_user],
      name: ['', data?.name],
      email: ['', data?.email],
      score: ['', data?.score],
      current_country: [null, data?.current_country],
      status: [null, data?.status],
      date_last_update: ['', data?.date_last_update],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      mobility: [[], data?.mobility],
      destination_country: [[], data?.destination_country],
      desired_workstation: ['', data?.desired_workstation],
      desired_contract: [[], data?.desired_contract],
      min_experience_years: ['', data?.min_experience_years],
      max_experience_years: ['', data?.max_experience_years],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
    });
  }

  freeSearchCandidat(pageNumber: number = this.currentPage) {
    this.isFormSubmitted = false;
    this.isFreeSearchFromSubmitted = true;
    let valueForm = this.freeSearchForm.value;

    let data = {
      page: this.currentPage +1,
      per_page: this.pageSize,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
      this.candidatservice.freeSearchcandidat(data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.spinner.hide();
              this.listcandidats = resSearch.data.data;
              this.totalItems = resSearch.data.total;
              this.spinner.hide();
              this.updateCandidats();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }

  /* search */
  searchCandidat(pageNumber: number = this.currentPage) {
      this.isFreeSearchFromSubmitted = false;
      this.isFormSubmitted = true;
      let valueForm = this.searchForm.value;
      valueForm.desired_salary_range = this.convertKToNumber(valueForm.desired_salary_range?.toString());
      let formattedEndDate = this.datePipe.transform(valueForm.date_last_update, 'yyyy-MM-dd');
      let data = {
          name: valueForm.name,
          score: valueForm.score,
          status: valueForm.status,
          ID_user: valueForm.ID_user,
          date_last_update: formattedEndDate,
          skillsOr: valueForm.skillsOr,
          skillsAnd: valueForm.skillsAnd,
          availability: valueForm.availability,
          desired_workstation: valueForm.desired_workstation,
          mobility: valueForm.mobility,
          desired_contract: valueForm.desired_contract,
          min_experience_years: valueForm.min_experience_years,
          max_experience_years: valueForm.max_experience_years,
          tjm: valueForm.tjm,
          tjm_range: valueForm.tjm_range,
          desired_salary: valueForm.desired_salary,
          desired_salary_range: valueForm.desired_salary_range,
          current_country: valueForm.current_country ? valueForm.current_country : '',
          destination_country: valueForm.destination_country ? valueForm.destination_country : '',
          page: this.currentPage +1,
          per_page: this.pageSize,
          sort: this.currentSortDirection,
          sortAttribute: this.sortAttr ?? 'id',
      };

      this.spinner.show();
      this.candidatservice.searchcandidat(data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.spinner.hide();
              this.startSearching = false;
              this.listcandidats = data;
              this.totalItems = total;
              this.spinner.hide();
              this.updateCandidats();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }



  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }

  getFormattedDate(): string {
    const dateValue = this.searchForm.get('date_last_update')!.value;
    // Format date to your desired format (e.g., YYYY-MM-DD)
    return moment(dateValue).format('DD/MM/YYYY');
  }

  reset() {
    this.currentPage = 0;
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchForm.get('mobility')?.setValue(null);
    this.searchForm.get('mobility')?.disable();

    this.isFormSubmitted = false;
  }

  resetFreeSearch() {
    this.currentPage = 0;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    // this.freeSearchForm.get('search')?.reset();
     this.getListcandidat();
    this.isFreeSearchFromSubmitted = false;
  }

  resetAdvancedSearch() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.stateList = [];
    this.searchCandidat(0);
  }

  onSubmit() {
    if (this.activeForm === 'freeSearch') {
      this.btnSearchactive = true;
      this.currentPage=0;
      this.freeSearchCandidat(0);
    } else {
      this.btnSearchactive = true;
      this.currentPage=0;
      this.searchCandidat(0);
    }
  }

  // Méthode pour gérer la réinitialisation des formulaires
  onReset() {
    this.stateList=[];
    this.currentPage = 0;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
     this.searchForm = this.createSearchForm();
     this.searchForm.reset();
     this.getListcandidat();
  }

  // exportToExcel(): void {
  //   const fileName = 'candidats.xlsx';
  //   if (this.selectedCandidats.length ) {
  //     // Utilisez selectedCandidats au lieu de listCandidat
  //     const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.selectedCandidats);
  //     const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, 'selectedCandidats'); // Mettez à jour le nom de la feuille si nécessaire
  //     XLSX.writeFile(wb, fileName);
  //   }else{
  //     this.toastrService.info("Veuillez sélectionner au moins un candidat.");
  //   }
  // }
  toggleCandidateSelection(candidateID: string): void {
    const index = this.selectedCandidates.indexOf(candidateID);
    if (index === -1) {
      this.selectedCandidates.push(candidateID);
    } else {
      this.selectedCandidates.splice(index, 1);
    }
  }
  redirectToLinkedIn(linkedinLink: string): void {
    window.open(linkedinLink, '_blank');
  }

  onCountryChange(mode: string): void {

    if (mode === 'reset') {
      this.searchForm.get('mobility')?.setValue(null);
      return;
    }

    this.searchForm.get('mobility')?.enable();
    this.countries = this.searchForm.get('destination_country')?.value;
    this.countries = this.countries.map(
      (item) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('mobility')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('mobility')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
    }
  }

  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('mobility')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('destination_country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('destination_country')?.setValue(new_array);
          }
        }
      }
    });

    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('mobility')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('mobility')?.disable();
      mode == 'add';
      this.searchForm.get('destination_country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
      this.searchForm.get('destination_country')!.updateValueAndValidity();
      this.searchForm.get('mobility')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }
  onMobilityChangeById(mobilities: any[], countries: any[], mode: string) {
    let paysLists: ICountry[] = Country.getAllCountries();
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);

      let difference1: any[] = [];
      if (countries.length > 0) {
        difference1 = this.findDuplicates(
          mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.candidateForm.get('destination_country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('mobility')?.value;
    if (
      (this.mobilities && this.mobilities.length === 0) ||
      this.stateList.length === 0
    ) {
      this.searchForm.get('mobility')?.disable();
      mode == 'add';
      this.searchForm.get('destination_country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
      this.searchForm.get('destination_country')!.updateValueAndValidity();
      this.searchForm.get('mobility')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  getRemainingMobilities(mobilityList: any): string {
    if (!Array.isArray(mobilityList) || mobilityList.length <= 3) {
      return '';
    }
    return mobilityList.map(m => String(m)).join(', ');
  }
  toggleRowSelection(candidat: ICandidat): void {
    candidat.checked = !candidat.checked;

    // Mettre à jour la sélection globale en fonction des cases individuelles
    this.headerChecked = this.listcandidats.every((c: any) => c.checked);

    // Mettre à jour la liste des candidats sélectionnés
    if (candidat.checked) {
      if (
        !this.selectedCandidats.some((el: ICandidat) => el.uuid === candidat.uuid)
      ) {
        this.selectedCandidats.push({ ...candidat, checked: true });
      }
    }
    else {
      this.selectedCandidats = this.selectedCandidats.filter(
        (el: ICandidat) => el.uuid !== candidat.uuid
      );
    }
  }

  navigate(user: any, name: string) {
    this.router.navigate([
      '/chat/chat-list',
      { user: user, name: name },
    ]);
  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    if(this.freeSearch) {
       this.searchForm = this.createSearchForm();
       this.searchForm.reset();
       this.getListcandidat();
       this.activeForm = 'freeSearch';
    }
    else {
      this.freeSearchForm.reset();
      this.freeSearchForm = this.createFreeSearchForm();
      this.getListcandidat();
      this.activeForm = 'guidedSearch'
    }
  }
  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  //@TOFIX: duplicated
  /**
   * Returns a string list of contract types for tooltip display based on contract type codes.
   * @param contractTypes - An array of contract type codes.
   * @returns A string listing the contract type names.
   */
  getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    if(Array.isArray(contractTypes)) return contractTypes?.map(type => contractMap[type.toString()] || '').join(', ');
    else return ''
  }

  //@TOFIX: duplicated
  /**
   * Returns a string list of skills for tooltip display.
   * @param contractTypes - An array of skills.
   * @returns A string listing the skills names.
   */
  getSkillsList(skillsList: string[]): string {
    if(Array.isArray(skillsList))  return skillsList.map(skill => skill).join(', ');
    else return ''
  }

    // @TOFIX: duplicated
/**
* Exports the CV of a candidate based on the specified type and company ID.
*
* @param {any} candidate - The selected candidate
* @param {number} type - The type of CV to export (e.g., 1 for standard, 2 for anonymous)
* @param {number | null} idCompany - The ID of the company for which the CV is being exported.
*                          Use `null` if no specific company is associated.
*/
exportCVCandidate( candidat: any, type: number, idCompany : number | null) {

  this.spinner.show();
  let candidate = {
    ids: [] as number[],
    last_name: null,
    first_name: null
  }

  if(candidat){
    candidate.ids= [candidat.uuid]

  } else{
    if (this.selectedCandidats.length > 0) {
      for (const iterator of this.selectedCandidats) {
        this.idsUsers.push(iterator.uuid);
      }
    }
    candidate.ids= this.idsUsers
    console.log('candidate.ids',candidate.ids)
  }
  const exportMethod = idCompany !== null
    ? this.exportService.exportCVEsnCandidate(candidate, type, idCompany)
    : this.exportService.exportCVWegestuCandidate(candidate, type);

  exportMethod.subscribe({
    next: () => {
      this.idsUsers = []
      this.spinner.hide();
    },
    error: () => {
      this.idsUsers = []
      this.spinner.hide();
    },
  });
}

downloadCVOriginal( candidate: any) {
  this.spinner.show();
  let candidateCvData = {
    fileNames: [] as string[],
    last_name: null,
    first_name: null
  }
  if(candidate){
    if(candidate.cv && candidate.cv !== 'null'){
      candidateCvData.first_name = candidate?.first_name
      candidateCvData.last_name = candidate?.last_name
      candidateCvData.fileNames = [candidate.cv]
    }else{
      this.spinner.hide();
      this.toastrService.info(EmptyCV);
      return;
    }
  }else{
    let allCvNull = true;
    for (let i = 0; i < this.selectedCandidats.length; i++) {
      const selectedCandidate = this.selectedCandidats[i];
      if (selectedCandidate.cv && selectedCandidate.cv !== 'null') {
        candidateCvData.fileNames.push(selectedCandidate.cv);
        allCvNull = false;
      }
    }
    if (allCvNull) {
      this.spinner.hide();
      this.toastrService.info(noCvSelected);
      return;
    }
  }

  this.exportService.exportCVCandidate(candidateCvData).subscribe({
    next: () => {
      this.idsUsers = []
      this.spinner.hide();
    },
    error: () => {
      this.idsUsers = []
      this.spinner.hide();
    },
  });
}
onPageChange(e: PageEvent): void {
  this.pageSize = e.pageSize;
  this.currentPage = e.pageIndex;
  if (this.searchForm.dirty && this.btnSearchactive) {
    this.searchCandidat(this.currentPage);
  }
  else if (this.freeSearchForm.dirty && this.btnSearchactive){
    this.freeSearchCandidat(this.currentPage);
  }
  else {
    this.getListcandidat();
  }
}
  subscriptionCanAccess(featureName: string): boolean {
    return this.subscriptionService.subscriptionCanAccess(featureName);
  }

  unSubscribedEsn(): boolean {
    return this.subscriptionService.unSubscribedEsn();
  }
  openModal(modalId: string): void {

    const nombreCoches = this.selectedCandidats.filter(
      (el: ICandidat) => el.checked
    ).length;
    if (nombreCoches > 3) {
      this.ischecked = false;
      this.toastrService.error(
        'Impossible de sélectionner plus de 3 candidats'
      );
    } else{
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }

  }


}
